@if (formFieldSignal(); as formField) {
    @if ((isChkTemplates() || !canShowExecuteMode()) && hasChkLicense) {
        @if (isChkTemplates()) {
            <div class="flex flex-wrap justify-between gap-y-4 pb-4 pt-2.5">
                <div class="flex items-center justify-end gap-2 text-sm font-semibold sm:justify-start">
                    @if (formField && formField.IsRequired) {
                        <span class="relative -top-1 h-5 text-xl leading-tight text-red-400">*</span>
                    }
                    @if (formField && formField.Hint) {
                        <bizz-popup class="ml-1" [title]="formField.Caption" [body]="formField.Hint"></bizz-popup>
                    }
                    @if (errorState?.Message; as errorMessage) {
                        <bizz-tooltip
                                class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"
                                [text]="errorMessage"></bizz-tooltip>
                    }
                </div>
            </div>
        }
        @if (!formField.IsReadOnly && !readOnlyOverride && !isProtectedCollectionField() && isChkTemplates()) {
            <div class="flex w-full flex-wrap items-center justify-between gap-2">
                <div class="flex flex-wrap gap-2">
                    <button (click)="toggleRowReordering()" [disabled]="pagedRecords().length <= 1"
                            class="cursor-pointer hover:bg-blue-500/80 hover:text-white maxw-sm:hidden"
                            [class]="{ 'bg-blue-500': rowReorderable, 'text-white': rowReorderable,
                        'bg-button': !rowReorderable}">
                        <bizz-icon iconName="circle-sort" class="size-4 min-w-4"></bizz-icon>
                        <span class="hidden xl:inline-block">{{ "Reorder" | translate }}</span>
                    </button>
                    <button class="default cursor-pointer" (click)="openGroupSortModal()">
                        <bizz-icon iconName="layer-group" class="size-4 min-w-4 text-default"></bizz-icon>
                        <span class="hidden xl:inline-block">{{ "ManageGroups" | translate }}</span>
                    </button>
                    @if (selection.length > 0 && !rowReorderable) {
                        <button class="default cursor-pointer" [disabled]="selection.length <= 0 || rowReorderable"
                                (click)="openLinkGroupModal()">
                            <bizz-icon iconName="layer-plus" class="size-4 min-w-4"></bizz-icon>
                            <span class="hidden xl:inline-block">{{ "AssignGroup" | translate }}</span>
                        </button>
                        <button class="default cursor-pointer" [disabled]="selection.length <= 0 || rowReorderable"
                                (click)="onSlectionDeleteClicked(selection)">
                            <bizz-icon iconName="trash-can" class="size-4 min-w-4"></bizz-icon>
                            <span class="hidden xl:inline-block">{{ "DeleteRecords" | translate }}</span>
                        </button>
                    }

                </div>
                <div class="flex gap-2">
                    <bizz-search [searchTerm]="searchTerm"
                                 (searchTermChange)="onSearchTermChanged($event)"></bizz-search>
                    <div class="button-group" #createMenuAnchor>
                        <button class="form-header-button save" type="button"
                                (click)="createQuestion()">
                            <bizz-icon
                                    class="header-popup-icon size-4 min-w-4 text-white"
                                    iconName="circle-plus">
                            </bizz-icon>
                            <span class="hidden text-white lg:inline-block">{{ "CreateQuestion" | translate }}</span>
                        </button>
                        <button class="form-header-button save" type="button"
                                (click)="toggleCreateMenuPopup($event)">
                            <bizz-toggle-arrow class="size-4" [direction]="showCreateMenuPopup ? 'up' : 'down'">
                            </bizz-toggle-arrow>
                        </button>
                    </div>
                </div>
            </div>
        }
        <div class="relative flex h-full w-full justify-between">
            @if (!isChkTemplates()) {
                <bizz-execute-checklist-preview
                        [canSave]="hasChkLicense && hasRecords() && !hasScheduler()"
                        [mode]="!hasChkLicense ? 'invalidChecklistsLicense' : hasRecords() ? 'save' : 'select'"
                        [loading]="hasChkLicense && formField.IsLoading"
                        (onSave)="save()">
                </bizz-execute-checklist-preview>
            }
            @if (pagedRecords(); as records) {
                <bizz-grid #bizzGridComponent
                           [class.!hidden]="!isChkTemplates()"
                           [rowReorderable]="rowReorderable"
                           [trackBy]="trackBy"
                           [loading]="formField.IsLoading"
                           [currentPage]="currentPage"
                           [readOnly]="readOnlyOverride || formField.IsReadOnly || !isChkTemplates()"
                           [totalItems]="activeRecords().length"
                           [gridData]="records"
                           [tabIndex]="(readOnlyOverride || formField.IsReadOnly) ? -1  : 0"
                           [gridOptions]="gridOptions"
                           [columnTemplate]="formColumnTemplate"
                           [commandColumnTemplate]="commandColumnTemplate"
                           [columnHeaderTemplate]="headerColumnTemplate"
                           [autoFitColumns]="false"
                           (pageChange)="pageChange($event)"
                           (cellAction)="onCellAction($event)"
                           (groupChange)="onGroupChange($event)"
                           (onRowDrop)="onRowDrop($event)"
                           (onRowDragEnter)="onRowDragEnter($event)"
                           [(selection)]="selection">
                </bizz-grid>
                <ng-template #commandColumnTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                <span class="flex items-center gap-2">
                    @if (rowReorderable) {
                        <bizz-icon class="inline-block size-3.5 text-list-row-action"
                                   iconName="sort"></bizz-icon>
                    } @else {
                        <bizz-from-field-grid-action-cell [record]="dataItem"
                                                          [formSignal]="form"
                                                          [actionsDisabled]="(readOnlyOverride || formField.IsReadOnly)"
                                                          [readOnlyOverwrite]="readOnlyOverride"
                                                          [tabIndex]="(readOnlyOverride || formField.IsReadOnly) ? -1  : 0"
                                                          [recordsSignal]="activeRecords"
                                                          [gridFieldSignal]="formFieldSignal"
                                                          [externalAccess]="externalAccess"
                                                          [formType]="formType()"
                                                          (openClicked)="onOpenRecordClicked($event)"
                                                          (editInNewWindowClicked)="onEditInNewWindowClicked($event)"
                                                          (editInlineClicked)="onEditInlineClicked(dataItem, rowIndex)"
                                                          (deleteClicked)="onDeleteClicked(dataItem, rowIndex)"
                                                          (saveClicked)="onSaveClicked(dataItem, rowIndex)"
                                                          (editDocumentClicked)="onEditDocumentClicked($event)">
                        </bizz-from-field-grid-action-cell>
                    }
                    </span>
                </ng-template>
                <ng-template #headerColumnTemplate let-column="column" let-columnIndex="columnIndex">
                    <div class="flex items-center gap-2">
                        @if (!(readOnlyOverride || formField.IsReadOnly || rowReorderable)) {
                            <!--TODO: RV talk to geert, column captions don't match protectedfieldtypes-->
                            @if (column.ProtectedFieldType ==
                            ProtectedFieldType.ChkTemplateQuestionCrosslinkIsPossibleAnswerNA ||
                            column.ProtectedFieldType ==
                            ProtectedFieldType.ChkTemplateQuestionCrosslinkIsPossibleAnswerNC ||
                            column.ProtectedFieldType ==
                            ProtectedFieldType.ChkTemplateQuestionCrosslinkIsRemarkRequired ||
                            column.ProtectedFieldType ==
                            ProtectedFieldType.ChkTemplateQuestionCrosslinkIsAttachmentRequired) {
                                <input type="checkbox" [checked]="isAllSelected(column)"
                                       (change)="titleCheckBoxClicked($event,column)" kendoCheckBox>
                            }
                        }
                        {{ column.title }}
                    </div>

                </ng-template>
                <ng-template #formColumnTemplate let-data let-column="column" let-columnIndex="columnIndex">
                    @if (data.EditMode) {
                        <bizz-form-control [isGridControl]="true"
                                           [formulaFieldIds]="formulaFieldIds"
                                           [formId]="formId"
                                           [tabIndex]="(readOnlyOverride || formField.IsReadOnly) ? -1  : 0"
                                           [fieldId]="column.CollectionFieldsID"
                                           [recordId]="data.CrossLinkedInstancesID"
                                           [gridFieldId]="formField.Id"
                                           [group]="formControl">
                        </bizz-form-control>
                    } @else {
                        <bizz-form-field-grid-cell [data]="data" [fieldId]="column.CollectionFieldsID"
                                                   [tabIndex]="(readOnlyOverride || formField.IsReadOnly) ? -1  : 0"
                                                   [gridColumn]="column"
                                                   (onCellAction)="onCellAction($event)">
                        </bizz-form-field-grid-cell>
                    }
                </ng-template>
            }
        </div>
    } @else {
        @if(hasChkLicense){
            <bizz-execute-checklist-control
                    [reportControl]="reportControl"
                    [formId]="formId"
                    [formFieldSignal]="formFieldSignal"
            ></bizz-execute-checklist-control>
        }@else{
            <bizz-execute-checklist-preview
                    [canSave]="false"
                    mode= 'invalidChecklistsLicense'
                    [loading]="false">
            </bizz-execute-checklist-preview>
        }
    }

}

@if (showCreateMenuPopup) {
    <kendo-popup #createMenuPopup
                 class="z-[1004] w-full sm:w-auto"
                 [margin]="{ horizontal: 0, vertical: 10 }"
                 [anchor]="createMenuAnchor"
                 [collision]="{ horizontal: 'fit', vertical: 'fit' }"
                 [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
                 [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
                 (anchorViewportLeave)="toggleCreateMenuPopup(undefined,false)">
        <div class="bizz-popup-content">
            <button class="form-header-button" type="button"
                    (click)="searchInList(); setCreateMenuPopup(false)">
                <bizz-icon
                        class="mr-2 h-5 w-5 sm:h-4 sm:w-4"
                        iconName="magnifying-glass">
                </bizz-icon>
                {{ "SearchInList" | translate }}
            </button>
            <button class="form-header-button" type="button"
                    (click)="createNewRowInstance(); setCreateMenuPopup(false)">
                <bizz-icon [title]="('AddQuestion' | translate)"
                           class="mr-2 h-5 w-5 sm:h-4 sm:w-4"
                           [hover]="true"
                           iconName="circle-plus">
                </bizz-icon>
                {{ 'AddItem' | translate }}
            </button>
        </div>
    </kendo-popup>
}